<template>
  <div class="store-list">
    <h1 class="page-title">
      店家管理
      <p class="subtitle">此處可以查看已建立的店家名單。</p>
    </h1>

    <div class="store-table">
      <div class="store-table__header">
        <h2 class="store-table__header--title">店家名單</h2>
        <router-link
          class="button is-primary store-table__header--action"
          to="/store/create"
        >
          <span class="icon-plus" />
          新增店家
        </router-link>

        <div class="columns">
          <div class="
            column
            is-full
            store-table__header--toggle-column"
          >
            <b-dropdown
              :close-on-click="false"
              aria-role="list"
              position="is-bottom-left"
              append-to-body
            >
              <template #trigger>
                <span class="icon-sort" />
                欄位調整
              </template>

              <b-dropdown-item
                aria-role="listitem"
                v-for="(column, index) in columns"
                :key="column.column"
              >
                <b-field>
                  <b-checkbox v-model="columns[index].visible">
                    {{ column.name }}
                  </b-checkbox>
                </b-field>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <b-table
          :data="filteredStoreList"
          :loading="loading"
          :mobile-cards="false"
          hoverable
          scrollable
          @select="editStore"
        >
          <b-table-column
            :th-attrs="columnThAttrs"
            :visible="columnVisibility.index"
            field="id"
            label="No."
            v-slot="props"
            width="60px"
          >
            {{ props.index + 1 + (page - 1) * perPage }}.
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="store_detail.name"
            label="店家名稱"
            width="200px"
            :visible="columnVisibility.name"
            sortable
            v-slot="props">
            {{ props.row.store_detail.name }}
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="tag"
            label="店家標籤"
            width="300px"
            :visible="columnVisibility.tag"
            v-slot="props">
            <b-taglist>
              <b-tag
                v-for="tag in props.row.store_tags"
                rounded
                :key="`tag-${tag.name}`">
                {{ tag.name }}
              </b-tag>
            </b-taglist>
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="store_close_days"
            label="公休日"
            width="200px"
            :visible="columnVisibility.closed_day"
            sortable
            v-slot="props">
            {{ transformClosedDay(props.row.store_close_days) }}
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="store_detail.city"
            label="地址"
            width="300px"
            :visible="columnVisibility.address"
            sortable
            v-slot="props">
            {{ props.row.store_detail.city }}
            {{ props.row.store_detail.dist }}
            {{ props.row.store_detail.address }}
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="store_detail.note"
            label="備註"
            width="160px"
            :visible="columnVisibility.note"
            sortable
            v-slot="props">
            {{ props.row.store_detail.note }}
          </b-table-column>
          <b-table-column
            :th-attrs="columnThAttrs"
            field="action"
            label="刪除"
            cell-class="store-table__action"
            width="60px"
            centered
            v-slot="props">
            <a
              href="#"
              @click.stop.prevent="onRemoveStore(props.row.id)">
              <span class="icon-trash" />
            </a>
          </b-table-column>

          <template #empty>
            <div v-if="!loading" class="store-table__empty">
              <p class="is-size-6 store-table__empty--title">
                尚未建立名單喔，立刻
                <router-link to="/store/create">新增店家</router-link>
                吧！
              </p>
              <section class="
                is-flex
                is-align-items-center
                is-justify-content-center
                store-table__empty--image
              ">
                <img
                  alt="Empty Store List"
                  src="@/assets/images/empty-store-list-image.svg"
                  width="50%"
                />
              </section>
            </div>
          </template>
        </b-table>
      </div>
      <div v-if="total && !loading" class="flex gap-4 items-center">
        <b-select v-model="perPage">
          <option
            v-for="option in perPageOptions"
            :value="option.value"
            :key="option.label"
          >
            {{ option.label }}
          </option>
        </b-select>
        <div class="flex-grow">
          <b-pagination
            :total="total"
            v-model="page"
            range-before="3"
            range-after="1"
            nextIcon="right-chevron"
            prevIcon="left-chevron"
            :per-page="perPage"
          />
        </div>
      </div>
    </div>

    <w-modal v-model="showConfirmation" type="danger">
      <template #header>刪除店家</template>
      <div slot="content">
        <div class="is-flex">
          <span class="icon-alert-circle has-text-red pt-1" />
          <p class="pl-4">
            確定刪除此店家嗎？刪除店家不會影響目前已有的訂購。
            <br>
            請注意，刪除後將無法還原店家。
          </p>
        </div>
      </div>
      <div slot="footer">
        <b-button
          type="is-danger"
          class="mr-4"
          outlined
          :disabled="loading"
          @click="showConfirmation = false">
          不刪除
        </b-button>
        <b-button
          type="is-danger"
          :disabled="loading"
          @click="removeStore">
          {{ loading ? '刪除中⋯' : '刪除' }}
        </b-button>
      </div>
    </w-modal>
  </div>
</template>

<script>
import StoreList from './StoreList';

export default StoreList;
</script>

<style lang="scss" scoped>
@import 'StoreList';
</style>
